import { render } from "./Dialog.vue?vue&type=template&id=5a2ab2ea&bindings={}"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script